import type { Config, ToolbarType } from "./types";

const htmlAllowedTags: Array<string> = [
  "a",
  "b",
  "blockquote",
  "br",
  "col",
  "colgroup",
  "em",
  "h1",
  "h2",
  "h3",
  "i",
  "li",
  "ol",
  "p",
  "strong",
  "table",
  "tbody",
  "td",
  "tfoot",
  "th",
  "thead",
  "tr",
  "u",
  "ul",
  "div",
];

const toolbarButtons: ToolbarType = [
  "undo",
  "redo",
  "|",
  "bold",
  "italic",
  "underline",
  "|",
  "paragraphFormat",
  "|",
  "quote",
  "|",
  "formatOL",
  "formatUL",
  "|",
  "insertTable",
  "|",
  "insertLink",
];

export default {
  language: "nb",
  placeholderText: "",
  toolbarSticky: false,
  paragraphFormatSelection: true,
  pluginsEnabled: ["link", "lists", "paragraphFormat", "quote", "table"],
  tableEditButtons: [
    "tableHeader",
    "tableRemove",
    "|",
    "tableRows",
    "tableColumns",
    "-",
    "tableCells",
    "tableCellVerticalAlign",
    "tableCellHorizontalAlign",
  ],
  linkEditButtons: ["linkOpen", "linkEdit", "linkRemove"],
  shortcutsEnabled: [
    "show",
    "bold",
    "italic",
    "underline",
    "indent",
    "outdent",
    "undo",
    "redo",
    "createLink",
  ],
  imageInsertButtons: ["imageBack", "|", "imageUpload", "imageManager"],
  imageEditButtons: [
    "imageDisplay",
    "imageAlign",
    "imageSize",
    "|",
    "imageLink",
    "linkOpen",
    "linkEdit",
    "linkRemove",
    "-",
    "imageCaption",
    "imageAlt",
    "imageReplace",
    "imageRemove",
  ],
  toolbarButtonsMD: null,
  toolbarButtonsSM: null,
  toolbarButtonsXS: null,
  imageDefaultWidth: 0,
  keepFormatOnDelete: true,
  paragraphFormat: {
    N: "Brødtekst",
    H1: "Overskrift 1",
    H2: "Overskrift 2",
    H3: "Overskrift 3",
  },
  htmlAllowedTags,
  toolbarButtons,
  fontSizeSelection: true,
  onInit: [],
} satisfies Config;
